import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Carousel from 'components/Carousel/Carousel';

import Slide from './Slide';
import SlidesContext from './SlidesContext';

const StyledContent = styled.div`
  text-align: center;
  padding: 0;
  width: 84%;
  margin: 0 auto;
`;

class Slides extends PureComponent {
  renderSlide = (slide, index) => {
    const { renderSlide } = this.props;

    return typeof renderSlide === 'function' ? (
      renderSlide(slide, index)
    ) : (
      <Slide {...slide} index={index} key={slide.title} />
    );
  };

  render() {
    const { currentStep, updateSlide, slides } = this.context;
    const { carouselProps } = this.props;

    return (
      <StyledContent>
        <Carousel
          {...carouselProps}
          currentStep={currentStep}
          onStepChanged={updateSlide}
          cardWidth={100}
        >
          {slides.map(this.renderSlide)}
        </Carousel>
      </StyledContent>
    );
  }
}

Slides.contextType = SlidesContext;

Slides.defaultProps = {
  renderSlide: undefined,
  carouselProps: {},
};

Slides.propTypes = {
  carouselProps: PropTypes.shape(Carousel.propTypes),
  renderSlide: PropTypes.func,
};

export default Slides;
